import React, { useEffect } from 'react';

import { pageTitle as pageTitleService } from 'services/pageTitle';

import { BreadcrumbItem, PageBreadcrumbs } from 'components/common/PageBreadcrumbs/PageBreadcrumbs';

import classes from './NavigationHeader.module.scss';

interface Props {
    pageTitle: string;
    items?: BreadcrumbItem[];
}

export const NavigationHeader = ({ pageTitle, items }: Props) => {
    useEffect(() => {
        pageTitleService.set(pageTitle);
    }, [pageTitle]);
    return (
        <div className={classes.NavigationHeader}>{items && items.length > 0 && <PageBreadcrumbs items={items} />}</div>
    );
};
